module.exports = __webpack_public_path__ + "media/images/brand/200/MARQUESBRANDINGCO LOGO VERTICAL W-10791c8c8c696f20bb4dd1d5749b7e06.png";